import React from 'react';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { VariableInputControlSlot } from '../VariableInputControlSlot';

export const Variables = ({ variables }: Props) => {
    // Note: Visibility filtering is now done at the selector level
    // (selectNonPinnedVariables and selectPinnedVariables filter by visible !== false)
    return (
        <>
            {variables.map(variable => (
                <VariableInputControlSlot
                    key={variable.id}
                    variableIds={[variable.id]}
                    render={(Control) => (<Cell><Control /></Cell>)} />
            ))}
        </>
    );
};

type Props = {
    variables: GiftJson.Variable<any>[];
};